import React, { useState, useEffect, useCallback } from 'react';
import { X, Check, XCircle, Clock, User, Mail } from 'lucide-react';
import api from '../utils/api';

export default function RequestsPanel({ onClose, onRefresh }) {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('pending');

  const fetchRequests = useCallback(async () => {
    setLoading(true);
    try {
      const data = await api.getRequests(filter);
      setRequests(data.requests || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [filter]);

  useEffect(() => { fetchRequests(); }, [fetchRequests]);

  const handleAction = async (id, action) => {
    try {
      await api.handleRequest(id, action);
      fetchRequests();
      if (action === 'accept') onRefresh?.();
    } catch (err) { alert(err.message); }
  };

  const formatDate = (d) => new Date(d).toLocaleString('vi-VN', { timeZone: 'Asia/Ho_Chi_Minh' });

  const priorityColors = { high: 'var(--priority-high)', medium: 'var(--priority-medium)', low: 'var(--priority-low)' };
  const priorityLabels = { high: 'Cao', medium: 'TB', low: 'Thấp' };
  const statusLabels = { pending: 'Chờ duyệt', accepted: 'Đã chấp nhận', rejected: 'Đã từ chối' };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal modal-md" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">Yêu cầu công việc</div>
          <button className="btn-icon" onClick={onClose}><X size={18} /></button>
        </div>

        <div className="tabs" style={{ padding: '0 24px' }}>
          {['pending', 'accepted', 'rejected'].map(s => (
            <button key={s} className={`tab ${filter === s ? 'active' : ''}`}
              onClick={() => setFilter(s)}>
              {statusLabels[s]}
            </button>
          ))}
        </div>

        <div className="modal-body" style={{ maxHeight: 400, overflowY: 'auto' }}>
          {loading ? (
            <div className="spinner" />
          ) : requests.length === 0 ? (
            <div className="empty-state">Không có yêu cầu nào</div>
          ) : (
            requests.map(r => (
              <div key={r.id} className="request-item">
                <div className="request-item-header">
                  <div>
                    <div className="request-item-title">{r.title}</div>
                    <div className="request-item-from">
                      <User size={12} style={{ marginRight: 4 }} /> {r.requester_name}
                      {r.requester_email && (
                        <span style={{ marginLeft: 8 }}>
                          <Mail size={12} style={{ marginRight: 4 }} /> {r.requester_email}
                        </span>
                      )}
                    </div>
                  </div>
                  <span className="badge" style={{ background: `${priorityColors[r.priority]}22`, color: priorityColors[r.priority] }}>
                    {priorityLabels[r.priority]}
                  </span>
                </div>
                <div className="request-item-desc">{r.description}</div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>
                    <Clock size={11} style={{ marginRight: 4 }} /> {formatDate(r.created_at)}
                  </span>
                  {r.status === 'pending' && (
                    <div className="request-item-actions">
                      <button className="btn btn-primary btn-sm" onClick={() => handleAction(r.id, 'accept')}>
                        <Check size={14} /> Chấp nhận
                      </button>
                      <button className="btn btn-danger btn-sm" onClick={() => handleAction(r.id, 'reject')}>
                        <XCircle size={14} /> Từ chối
                      </button>
                    </div>
                  )}
                  {r.status !== 'pending' && r.accepted_by_name && (
                    <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>
                      Bởi: {r.accepted_by_name}
                    </span>
                  )}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
